/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as AppRouteImport } from './routes/_app'
import { Route as LoginRouteImport } from './routes/login'
import { Route as AppIndexRouteImport } from './routes/_app/index'
import { Route as AppDashboardRouteImport } from './routes/_app/dashboard'
import { Route as AppIntroRouteImport } from './routes/_app/intro'
import { Route as AppPeriodsRouteImport } from './routes/_app/periods'
import { Route as AppResultsRouteImport } from './routes/_app/results'
import { Route as AppReviewRouteImport } from './routes/_app/review'
import { Route as AppSettingsRouteImport } from './routes/_app/settings'
import { Route as AppTeamRouteImport } from './routes/_app/team'
import { Route as AppWhatsNewRouteImport } from './routes/_app/whats-new'
import { Route as AppAssessGroupIdRouteImport } from './routes/_app/assess.$groupId'
import { Route as AppMembersIndexRouteImport } from './routes/_app/members.index'
import { Route as AppMembersUserIdRouteImport } from './routes/_app/members.$userId'

const AppRoute = AppRouteImport.update({
  id: '/_app',
  getParentRoute: () => rootRouteImport,
} as any)
const LoginRoute = LoginRouteImport.update({
  id: '/login',
  path: '/login',
  getParentRoute: () => rootRouteImport,
} as any)
const AppIndexRoute = AppIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AppRoute,
} as any)
const AppDashboardRoute = AppDashboardRouteImport.update({
  id: '/dashboard',
  path: '/dashboard',
  getParentRoute: () => AppRoute,
} as any)
const AppIntroRoute = AppIntroRouteImport.update({
  id: '/intro',
  path: '/intro',
  getParentRoute: () => AppRoute,
} as any)
const AppPeriodsRoute = AppPeriodsRouteImport.update({
  id: '/periods',
  path: '/periods',
  getParentRoute: () => AppRoute,
} as any)
const AppResultsRoute = AppResultsRouteImport.update({
  id: '/results',
  path: '/results',
  getParentRoute: () => AppRoute,
} as any)
const AppReviewRoute = AppReviewRouteImport.update({
  id: '/review',
  path: '/review',
  getParentRoute: () => AppRoute,
} as any)
const AppSettingsRoute = AppSettingsRouteImport.update({
  id: '/settings',
  path: '/settings',
  getParentRoute: () => AppRoute,
} as any)
const AppTeamRoute = AppTeamRouteImport.update({
  id: '/team',
  path: '/team',
  getParentRoute: () => AppRoute,
} as any)
const AppWhatsNewRoute = AppWhatsNewRouteImport.update({
  id: '/whats-new',
  path: '/whats-new',
  getParentRoute: () => AppRoute,
} as any)
const AppAssessGroupIdRoute = AppAssessGroupIdRouteImport.update({
  id: '/assess/$groupId',
  path: '/assess/$groupId',
  getParentRoute: () => AppRoute,
} as any)
const AppMembersIndexRoute = AppMembersIndexRouteImport.update({
  id: '/members/',
  path: '/members/',
  getParentRoute: () => AppRoute,
} as any)
const AppMembersUserIdRoute = AppMembersUserIdRouteImport.update({
  id: '/members/$userId',
  path: '/members/$userId',
  getParentRoute: () => AppRoute,
} as any)

export interface FileRoutesByFullPath {
  '/': typeof AppIndexRoute
  '/login': typeof LoginRoute
  '/dashboard': typeof AppDashboardRoute
  '/intro': typeof AppIntroRoute
  '/periods': typeof AppPeriodsRoute
  '/results': typeof AppResultsRoute
  '/review': typeof AppReviewRoute
  '/settings': typeof AppSettingsRoute
  '/team': typeof AppTeamRoute
  '/whats-new': typeof AppWhatsNewRoute
  '/assess/$groupId': typeof AppAssessGroupIdRoute
  '/members/$userId': typeof AppMembersUserIdRoute
  '/members/': typeof AppMembersIndexRoute
}
export interface FileRoutesByTo {
  '/login': typeof LoginRoute
  '/dashboard': typeof AppDashboardRoute
  '/intro': typeof AppIntroRoute
  '/periods': typeof AppPeriodsRoute
  '/results': typeof AppResultsRoute
  '/review': typeof AppReviewRoute
  '/settings': typeof AppSettingsRoute
  '/team': typeof AppTeamRoute
  '/whats-new': typeof AppWhatsNewRoute
  '/': typeof AppIndexRoute
  '/assess/$groupId': typeof AppAssessGroupIdRoute
  '/members/$userId': typeof AppMembersUserIdRoute
  '/members': typeof AppMembersIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/_app': typeof AppRouteWithChildren
  '/login': typeof LoginRoute
  '/_app/dashboard': typeof AppDashboardRoute
  '/_app/intro': typeof AppIntroRoute
  '/_app/periods': typeof AppPeriodsRoute
  '/_app/results': typeof AppResultsRoute
  '/_app/review': typeof AppReviewRoute
  '/_app/settings': typeof AppSettingsRoute
  '/_app/team': typeof AppTeamRoute
  '/_app/whats-new': typeof AppWhatsNewRoute
  '/_app/': typeof AppIndexRoute
  '/_app/assess/$groupId': typeof AppAssessGroupIdRoute
  '/_app/members/$userId': typeof AppMembersUserIdRoute
  '/_app/members/': typeof AppMembersIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/login'
    | '/dashboard'
    | '/intro'
    | '/periods'
    | '/results'
    | '/review'
    | '/settings'
    | '/team'
    | '/whats-new'
    | '/assess/$groupId'
    | '/members/$userId'
    | '/members/'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/login'
    | '/dashboard'
    | '/intro'
    | '/periods'
    | '/results'
    | '/review'
    | '/settings'
    | '/team'
    | '/whats-new'
    | '/'
    | '/assess/$groupId'
    | '/members/$userId'
    | '/members'
  id:
    | '__root__'
    | '/_app'
    | '/login'
    | '/_app/dashboard'
    | '/_app/intro'
    | '/_app/periods'
    | '/_app/results'
    | '/_app/review'
    | '/_app/settings'
    | '/_app/team'
    | '/_app/whats-new'
    | '/_app/'
    | '/_app/assess/$groupId'
    | '/_app/members/$userId'
    | '/_app/members/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  AppRoute: typeof AppRouteWithChildren
  LoginRoute: typeof LoginRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/_app': {
      id: '/_app'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof AppRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/login': {
      id: '/login'
      path: '/login'
      fullPath: '/login'
      preLoaderRoute: typeof LoginRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_app/': {
      id: '/_app/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof AppIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/dashboard': {
      id: '/_app/dashboard'
      path: '/dashboard'
      fullPath: '/dashboard'
      preLoaderRoute: typeof AppDashboardRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/intro': {
      id: '/_app/intro'
      path: '/intro'
      fullPath: '/intro'
      preLoaderRoute: typeof AppIntroRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/periods': {
      id: '/_app/periods'
      path: '/periods'
      fullPath: '/periods'
      preLoaderRoute: typeof AppPeriodsRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/results': {
      id: '/_app/results'
      path: '/results'
      fullPath: '/results'
      preLoaderRoute: typeof AppResultsRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/review': {
      id: '/_app/review'
      path: '/review'
      fullPath: '/review'
      preLoaderRoute: typeof AppReviewRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/settings': {
      id: '/_app/settings'
      path: '/settings'
      fullPath: '/settings'
      preLoaderRoute: typeof AppSettingsRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/team': {
      id: '/_app/team'
      path: '/team'
      fullPath: '/team'
      preLoaderRoute: typeof AppTeamRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/whats-new': {
      id: '/_app/whats-new'
      path: '/whats-new'
      fullPath: '/whats-new'
      preLoaderRoute: typeof AppWhatsNewRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/assess/$groupId': {
      id: '/_app/assess/$groupId'
      path: '/assess/$groupId'
      fullPath: '/assess/$groupId'
      preLoaderRoute: typeof AppAssessGroupIdRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/members/': {
      id: '/_app/members/'
      path: '/members'
      fullPath: '/members/'
      preLoaderRoute: typeof AppMembersIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/members/$userId': {
      id: '/_app/members/$userId'
      path: '/members/$userId'
      fullPath: '/members/$userId'
      preLoaderRoute: typeof AppMembersUserIdRouteImport
      parentRoute: typeof AppRoute
    }
  }
}

interface AppRouteChildren {
  AppDashboardRoute: typeof AppDashboardRoute
  AppIntroRoute: typeof AppIntroRoute
  AppPeriodsRoute: typeof AppPeriodsRoute
  AppResultsRoute: typeof AppResultsRoute
  AppReviewRoute: typeof AppReviewRoute
  AppSettingsRoute: typeof AppSettingsRoute
  AppTeamRoute: typeof AppTeamRoute
  AppWhatsNewRoute: typeof AppWhatsNewRoute
  AppIndexRoute: typeof AppIndexRoute
  AppAssessGroupIdRoute: typeof AppAssessGroupIdRoute
  AppMembersUserIdRoute: typeof AppMembersUserIdRoute
  AppMembersIndexRoute: typeof AppMembersIndexRoute
}

const AppRouteChildren: AppRouteChildren = {
  AppDashboardRoute: AppDashboardRoute,
  AppIntroRoute: AppIntroRoute,
  AppPeriodsRoute: AppPeriodsRoute,
  AppResultsRoute: AppResultsRoute,
  AppReviewRoute: AppReviewRoute,
  AppSettingsRoute: AppSettingsRoute,
  AppTeamRoute: AppTeamRoute,
  AppWhatsNewRoute: AppWhatsNewRoute,
  AppIndexRoute: AppIndexRoute,
  AppAssessGroupIdRoute: AppAssessGroupIdRoute,
  AppMembersUserIdRoute: AppMembersUserIdRoute,
  AppMembersIndexRoute: AppMembersIndexRoute,
}

const AppRouteWithChildren = AppRoute._addFileChildren(AppRouteChildren)

const rootRouteChildren: RootRouteChildren = {
  AppRoute: AppRouteWithChildren,
  LoginRoute: LoginRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
